<template>
  <!--11-3教育机构应聘人才应聘案件显示列表-->

  <div class="main-css">
    <!--    标题-->
    <div class="main-box">
      <div class="inline-box">
        <div class="one-box-left">
          <div class="one-box-left1">
            <img :src="imgUrl?imgUrl:'@/assets/defaultImg.png'" alt=""  @error="
                  e => {
                    e.target.src = require('@/assets/defaultImg.png');
                  }
                "/>
          </div>
          <div class="one-box-left2">
            <div class="one-box-left-line1">
              <div class="one-box-left-line-smallleft">
                <p></p>
              </div>
              <div class="one-box-left-line-smallright">
                <p>{{ List.anonym }}</p>
              </div>
            </div>
            <div class="one-box-left-line2">
              <div class="one-box-left-line-smallleft">
                <p>{{ $t("name") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p>{{ List.name }}</p>
              </div>
            </div>
            <div class="one-box-left-line3">
              <div class="one-box-left-line-smallleft">
                <p>{{ $t("sex") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p v-if="language === 'ja-JP'">{{ List.jpsex_dictText }}</p>
                <p v-else>{{ List.sex_dictText }}</p>
              </div>
            </div>
            <div class="one-box-left-line4">
              <div class="one-box-left-line-smallleft">
                <p>{{ $t("birth") }}</p>
              </div>
              <div class="one-box-left-line-smallright-long">
                <p v-if="List.birth">{{ List.birth.split(" ")[0] }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="one-box-right">
          <div class="one-box-right1">
            <div class="one-box-left-line1-line">
              <div class="one-box-left-line-smallleft">
                <p>{{ $t("education") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p></p>
              </div>
            </div>
            <div class="one-box-left-line2">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("period") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <el-tooltip :content="'2018.08 ~ 2022.06'" placement="top">
                  <p>2018.08 ~ 2022.06</p>
                </el-tooltip>
              </div>
            </div>
            <div class="one-box-left-line3">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("school") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <el-tooltip
                  :content="List.school"
                  placement="top"
                  :disabled="String(List.school).length >= 10 ? false : true"
                >
                  <p>{{ List.school }}</p>
                </el-tooltip>
              </div>
            </div>
            <div class="one-box-left-line4">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("major") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <el-tooltip
                  :content="List.profession"
                  placement="top"
                  :disabled="String(List.profession).length > 10 ? false : true"
                >
                  <p>{{ List.profession }}</p>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="one-box-right2">
            <div class="one-box-left-line1-line">
              <div class="one-box-left-line-smallleft">
                <p>{{ $t("languageSkills") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p></p>
              </div>
            </div>
            <div class="one-box-left-line2">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("japanese") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p v-if="language === 'ja-JP'">
                  {{ List.jpjapanese_dictText }}
                </p>
                <p v-else>{{ List.japanese_dictText }}</p>
              </div>
            </div>
            <div class="one-box-left-line3">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("english") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <p v-if="language === 'ja-JP'">{{ List.jpenglish_dictText }}</p>
                <p v-else>{{ List.english_dictText }}</p>
              </div>
            </div>
            <div class="one-box-left-line4">
              <div class="one-box-left-line-smallright">
                <p>{{ $t("other") }}</p>
              </div>
              <div class="one-box-left-line-smallright">
                <el-tooltip
                  :content="List.other"
                  placement="top"
                  :disabled="String(List.other).length > 10 ? false : true"
                >
                  <p>{{ List.other }}</p>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- table部分 -->
      <div class="table">
        <div class="line-button-box">
          <el-button type="warning" @click="goDetail">
            {{ $t("peopleDetail") }}
          </el-button>
        </div>
        <el-table
          @row-click="returns"
          :data="tableData"
          style="width: 95%"
          height="370"
          @sort-change="changeTableSort"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :cell-style="rowStyle"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------案件番号---------------------- -->
          <el-table-column prop="caseNumber" label="案件番号" width="110px">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
              <el-input
                @blur="fuzzy"
                v-model="searchData1"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.jobId" placement="bottom">
                <p
                  style="text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;"
                >
                  {{ scope.row.jobId }}
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column
            prop="caseName"
            label="案件名"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                @blur="fuzzy"
                v-model="searchData2"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.jobName }}
            </template>
          </el-table-column>
          <!-- ----------------------医療機関---------------------- -->
          <el-table-column
            prop="medicalInstitution"
            label="医療機関"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                @blur="fuzzy"
                v-model="searchData3"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.medicalName }}
            </template>
          </el-table-column>
          <!-- ----------------------勤務地---------------------- -->
          <el-table-column
            prop="onDuty"
            label="勤務地"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workLocation") }}</p>
              <el-input
                @blur="fuzzy"
                v-model="searchData4"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.workSpace }}
            </template>
          </el-table-column>
          <!-- ----------------------掲載日---------------------- -->
          <el-table-column
            prop="publicationDate"
            label="掲載日"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("payonTheDay") }}</p>
              <!-- <el-input
                @blur="fuzzy"
                v-model="searchData5"
                size="mini"
                placeholder="Search"
              /> -->
              <el-date-picker
                v-model="searchData5"
                type="date"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd"
                clearable
                style="width: 120px"
                :placeholder="$t('registerDayselsect')"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope" v-if="scope.row.createTime">
              {{ scope.row.createTime.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ----------------------担当者---------------------- -->
          <el-table-column
            prop="responsiblePerson"
            label="担当者"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input
                @blur="fuzzy"
                v-model="searchData6"
                size="mini"
                placeholder="Search"
              />
            </template>
            <template slot-scope="scope">
              <img
                src="./assets/name-img.png"
                alt=""
                class="table-img-css"
                @click=""
              />
              <span style="margin-left: 10px">{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------観覧回数 ---------------------- -->
          <el-table-column
            prop="numberOfViewings"
            label="観覧回数 "
            :sortable="'custom'"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("numberOfVisits") }}</p>
              <el-input @blur="fuzzy" v-model="searchData7" size="mini" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
          <!-- --------------------------状態-------------------------- -->
          <el-table-column prop="reviewStatus" label="状態" width="150">
            <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandStatus">
                <span class="el-dropdown-link">
                  {{ status }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in StatusData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpreviewStatus_dictText
              }}</span>
              <span v-else>{{ scope.row.reviewStatus_dictText }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="tableTotal"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 个人简历弹出层 -->
    <el-dialog
      title="个人简历浏览"
      class="selfDialog"
      :visible.sync="addDialogVisible"
      width="30%"
    >
      <div class="left-box">
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <!-- 显示图片 -->
          <div class="case-img">
            <!--图片未传-->
            <div class="one-box-left1">
              <img :src="img?img:'@/assets/defaultImg.png'"   @error="
                  e => {
                    e.target.src = require('@/assets/defaultImg.png');
                  }
                " alt="" />
            </div>
            <div class="one-box-left2">
              <div class="one-box-left-line1">
                <div class="one-box-left-line-smallleft">
                  <p></p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.anonym }}</p>
                </div>
              </div>
              <div class="one-box-left-line2">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("name") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.name }}</p>
                </div>
              </div>
              <div class="one-box-left-line3">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("sex") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <span v-if="language == 'ja-JP'">{{
                    this.infoList.jpsex_dictText
                  }}</span>
                  <span v-else>{{ this.infoList.sex_dictText }}</span>
                </div>
              </div>
              <div class="one-box-left-line4">
                <div class="one-box-left-line-smallleft">
                  <p>{{ $t("birth") }}</p>
                </div>
                <div class="one-box-left-line-smallright">
                  <p>{{ infoList.birth && infoList.birth.split(" ")[0] }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 标签部分 -->
          <div class="label">
            <!--qaq-->
            <div class="label-box-active" v-if="this.infoList.label1 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.infoList.jplabel1_dictText }}
              </div>
              <div v-else>{{ this.infoList.label1_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.infoList.label2 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.infoList.jplabel2_dictText }}
              </div>
              <div v-else>{{ this.infoList.label2_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.infoList.label3 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.infoList.jplabel3_dictText }}
              </div>
              <div v-else>{{ this.infoList.label3_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.infoList.label1 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.infoList.jplabel1_dictText }}
              </div>
              <div v-else>{{ this.infoList.label1_dictText }}</div>
            </div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("contactAddress") }}</div>
              <div class="inline-left-title-main">
                {{ $t("currentAddress") }}
                <div
                  class="inline-left-title-main-right"
                  :title="infoList.address"
                >
                  {{ infoList.address }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("email") }}
                <div
                  class="inline-left-title-main-right"
                  :title="infoList.email"
                >
                  {{ infoList.email }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("telephoneNumber") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.telephone }}
                </div>
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("education") }}</div>

              <div class="inline-left-title-main">
                {{ $t("period") }}
                <div class="inline-left-title-main-right-long">
                  {{
                    infoList.enrollment && infoList.enrollment.split(" ")[0]
                  }}~{{
                    infoList.enrollment && infoList.graduation.split(" ")[0]
                  }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("school") }}
                <div
                  class="inline-left-title-main-right"
                  :title="infoList.school"
                >
                  {{ infoList.school }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("major") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.profession }}
                </div>
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("qualification") }}</div>
              <div class="inline-left-title-main">
                {{ infoList.qualification1 }}
              </div>

              <div class="inline-left-title-main">
                {{ infoList.qualification2 }}
              </div>

              <div class="inline-left-title-main">
                {{ infoList.qualification3 }}
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("workHistory") }}</div>
              <div class="inline-left-title-main">
                {{ $t("period") }}
                <div class="inline-left-title-main-right-long">
                  {{ infoList.startYear && infoList.startYear.split(" ")[0] }}
                  &#12288;
                  {{ infoList.endYear && infoList.endYear.split(" ")[0] }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("companyName") }}
                <div
                  class="inline-left-title-main-right"
                  :title="infoList.hopeWorkplace"
                >
                  {{ infoList.hopeWorkplace }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("affiliation") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.type }}
                </div>
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("languageSkills") }}</div>
              <div class="inline-left-title-main">
                {{ $t("japanese") }}
                <div class="inline-left-title-main-right">
                  <span v-if="language == 'ja-JP'">{{
                    this.infoList.jpjapanese_dictText
                  }}</span>
                  <span v-else>{{ this.infoList.japanese_dictText }}</span>
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("english") }}
                <div class="inline-left-title-main-right">
                  <span v-if="language == 'ja-JP'">{{
                    this.infoList.jpenglish_dictText
                  }}</span>
                  <span v-else>{{ this.infoList.english_dictText }}</span>
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("other") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.other }}
                </div>
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("request") }}</div>

              <div class="inline-left-title-main-long">
                {{ $t("joinCompany") }}
                <div class="inline-left-title-main-right-long">
                  {{
                    infoList.startYear && infoList.startYear.split(" ")[0]
                  }}~{{ infoList.endYear && infoList.endYear.split(" ")[0] }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("workLocation") }}
                <div
                  class="inline-left-title-main-right"
                  :title="infoList.workPlace"
                >
                  {{ infoList.workPlace }}
                </div>
              </div>

              <div class="inline-left-title-main">
                {{ $t("occupation") }}
                <div class="inline-left-title-main-right">
                  {{ infoList.profession }}
                </div>
              </div>
            </div>
          </div>

          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("selfPR") }}</div>
            <div class="long-box-main">
              {{ infoList.pr }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  resumeApplyJob,
  fuzzyResumeApplyJob,
  getUrlFromOSS,
  resumeDetailQuery
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "educationalInstitutionAddRecruiter",
  components: {},
  data() {
    return {
      StatusData: [],
      imgUrl: "",
      List: null,
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      tableTotal: 0,
      loading: false,
      language: "",
      statusCode: 0,
      status: "ALL",
      jobIdS: "",
      img: "",
      infoList: [],
      addDialogVisible: false
    };
  },

  created() {
    this.language = this.$i18n.locale;
    console.log( this.$route)
    console.log(6666, this.$route.params.row);
    this.List = this.$route.params.row;
    this.jobIdS = this.$route.params.row.resumeId;
    this.getUrlList(this.List.avatar);
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.getReviewStatus();
    this.selects();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    goDetail() {
      this.getResumeDetailQuery(this.jobIdS);
      this.addDialogVisible = true;
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    dataTimeChange() {
      this.principalTime = this.timeJs(this.searchData5);
      this.fuzzy();
    },
    pickerChangeFn(value) {
      if (value === null) {
        this.principalTime = "";
        this.fuzzy();
      }
    },
    //图片回显
    getUrl(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.img = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //通过人才id查看人才详细信息
    getResumeDetailQuery(resumeId) {
      var fescInfo = {
        //  resumeId:"2da41ebca92545388edb89ce3f513vcb",
        resumeId: resumeId
      };
      resumeDetailQuery(fescInfo)
        .then(res => {
          console.log("--------通过人才id查看人才详细信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.infoList = aesFecInfo.data[0];
            this.getUrl(this.infoList.avatar);
          }
        })
        .catch(res => {
          console.log("通过人才id查看人才详细信息接口异常:", res);
        });
    },
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据6------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.List = that.$route.params.row;
        that.getUrlList(that.List.avatar);
        that.searchDataStart = that.$route.query.searchData;
        console.log(that.searchDataStart);
        that.getReviewStatus();
        that.selects();
      }
    },
    getReviewStatus() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpjobReviewStatus";
      } else {
        dataItems = "jobReviewStatus";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据reviewStatus--------");

            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.StatusData = aesFecInfo.data;
            console.log(that.StatusData);
            that.StatusData.push({
              name: "全部",
              code: ""
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommandStatus(evt) {
      console.log(evt, "eee");
      this.statusCode = evt.code;
      this.status = evt.name;
      this.fuzzy();
    },
    getUrlList(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.imgUrl = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //跳转到应聘详情页面15-2
    returns(row, event, column) {
      if (event.property === "medicalInstitution") {
        this.$router.push({
          name: "educationViewJobInformation",
          query: {
            id: row.jobId
          }
        });
      } else {
        this.$router.push({
          name: "detailsOfApplicantsForCasesInEducationalInstitutions",
          query: {
            row: JSON.stringify(row)
          }
        });
      }
      console.log(row);
      console.log(event);
    },
    fuzzy() {
      var fuzzyQueryDTO = {
        createTimeStart: this.searchData5,
        jobId: this.searchData1,
        jobName: this.searchData2,
        medicalName: this.searchData3,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        userName: this.searchData6,
        visitedTime: this.searchData7,
        workSpace: this.searchData4,
        resumeId: this.List.resumeId,
        reviewStatus: this.statusCode
      };
      fuzzyResumeApplyJob(fuzzyQueryDTO)
        .then(res => {
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.tableData = aesFecInfo.data;
            console.log(this.tableData, "blurblur");
          }
        })
        .catch(res => {
          console.log("失败:", res);
        });
    },
    //表格数据
    selects() {
      var applicationStatusDTO = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        resumeId: this.List.resumeId
      };
      resumeApplyJob(applicationStatusDTO)
        .then(res => {
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.tableData = aesFecInfo.data;
            this.tableTotal = aesFecInfo.data.length;
            console.log(this.tableData);
          }
        })
        .catch(res => {
          console.log("失败:", res);
        });
    },
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "solicitor") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["solicitor"] - b["solicitor"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["solicitor"] - a["solicitor"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["returnNumber"] - b["returnNumber"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["returnNumber"] - a["returnNumber"]
          );
        }
      }
    },
    //页码变化
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.selects();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.currentPage = 1;
      this.selects();
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    rowStyle() {
      return "text-align:center";
    }
  }
};
</script>
<style>
.el-input__icon {
  display: none !important;
}
</style>
<style scoped>
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css2 {
  background-color: #ffffff;
}
.main-css {
  width: 100%;
  height: 100%;
}
.main-box {
  width: 100%;
  height: 80%;
  /* padding: 0 40px 0 80px; */
  box-sizing: border-box;
}

.inline-box {
  height: 150px;
  width: 100%;
  margin-top: 120px;
  display: flex;
}
.one-box-left {
  width: 500px;
  height: 150%;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}
.one-box-left1 {
  width: 350px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}
.one-box-left2 {
  width: 600px;
  height: 266px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}
.one-box-left-line1 {
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line1-line {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #686868;
  margin-top: 13px;
}
.one-box-left-line2 {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line3 {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line4 {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line-smallleft {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}
.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.25px;

  /* 灰色字体 */

  color: #686868;
}
.one-box-left-line-smallright p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.one-box-left-line-smallright-long {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.25px;

  /* 灰色字体 */

  color: #686868;
}

.one-box-right {
  width: 50%;
  height: 150%;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}
.one-box-right1 {
  width: 50%;
  height: 266px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-right2 {
  width: 50%;
  height: 266px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}
.table {
  height: 420px;
  width: 100%;
  margin-top: 80px;
}

.table /deep/ .cell {
  text-align: center;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  width: 100px;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 50px;
}
.pagination-main {
  float: right;
  margin-right: 100px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.table-img-css {
  border-radius: 50%;
}
</style>
<style scoped>
.selfDialog /deep/ .el-dialog {
  min-width: 600px !important;
}

.selfDialog .left-box {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.selfDialog .top-title {
  height: 40px;
  width: 530px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.selfDialog .case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.selfDialog .main-left-box {
  /*overflow-y: scroll;*/
  overflow-y: hidden;
}

.selfDialog .case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.selfDialog .label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.selfDialog .inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.selfDialog .inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.selfDialog .inline-left-title-main {
  width: 100%;
  min-width: 140px;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.selfDialog .inline-left-title-main-long {
  width: 100%;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.selfDialog .inline-left-title-main-right {
  width: calc(100% - 60px);
  /* line-height: 50px; */
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.selfDialog .inline-left-title-main-right-long {
  width: calc(100% - 60px);
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
}

.selfDialog .inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.selfDialog .inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.selfDialog .long-box-title {
  /*height: 360px;*/
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.selfDialog .long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.selfDialog .label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.selfDialog .one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.selfDialog .one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line4 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.selfDialog .one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.selfDialog .label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.selfDialog .label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.selfDialog .label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.selfDialog .left-box {
  width: 550px;
  height: 800px;
  /*float: left;*/
  overflow: hidden;
  padding-bottom: 20px;
  position: relative;
}

.selfDialog .main-left-box {
  width: 100%;
  height: max-content;
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
}

.selfDialog .case-name {
  height: 55px;
  width: 100%;
}

.selfDialog .case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.selfDialog .case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.selfDialog .case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.selfDialog .case-img img {
  width: 150px;
  height: 114px;
}

.selfDialog .label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.selfDialog .label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.selfDialog .label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.selfDialog .left-button {
  width: 100%;
  height: 41px;
}

.selfDialog .inline-left {
  width: 200px;
  height: max-content;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.selfDialog .inline-right {
  width: 240px;
  height: 140px;
  margin-right: 45px;
  float: left;
}

.selfDialog .inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.selfDialog .inline-box {
  height: max-content;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.selfDialog .long-box-title {
  height: max-content;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.selfDialog .one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.selfDialog .one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.selfDialog .one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selfDialog .one-box-left-line-smallleft {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  font-size: 15px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.selfDialog .one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.selfDialog .label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.selfDialog .label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.info-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionsTalentApplicationList/index.vue